import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Task } from 'src/app/models/Task';
import { AnalyticsTask } from 'src/app/models/AnalyticsTask';
import { HelpersService } from 'src/app/services/shared/helpers.service';
@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit, OnChanges {
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { x: {}, y: {} },
    plugins: {
      datalabels: {
        display: false,
      }
    }
  };
  public barChartLabels: string[] = [];
  public barChartLabelsDuration: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public barChartColors: any[] = [{
    backgroundColor: 'lightblue',
    borderColor: 'lightblue',
    pointBackgroundColor: 'lightblue',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
  }
  ];
  public barChartColorsDuration: any[] = [{
    backgroundColor: '#FFC04C',
    borderColor: 'orange',
    pointBackgroundColor: 'orange',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
  }
  ];
  public barChartData: ChartDataset[] = [];
  public barChartDataDuration: ChartDataset[] = [];

  @Input() dataset: Array<AnalyticsTask>;
  @Input() cooperationsName;
  public mobile;
  public loaded = false;
  constructor(public helpers: HelpersService) { }

  ngOnInit() {

  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.drawBarChart();
    }
  }

  drawBarChart() {

    let dataArray = [];
    let count = 0;
    for (let item of this.cooperationsName) {
      if (this.dataset != undefined) {
        for (let i = 0; i < this.dataset.length; i++) {
          if (this.dataset[i].company === item) {
            count++;
          }
        }
        dataArray.push(count);
        count = 0;
      }
    }
    let outArrayOpravila = this.helpers.doGraphSorter(this.cooperationsName, dataArray);
    let outLabelsOpravila = [];
    let outValuesOpravila = [];
    for (let item of outArrayOpravila) {
      if (item.value > 0) {
        outLabelsOpravila.push(item.label);
        outValuesOpravila.push(item.value);
      }
    }

    this.barChartLabels = outLabelsOpravila;
    this.barChartData = [{
      data: outValuesOpravila,
      label: 'Število porabljenih minut',
      backgroundColor: 'lightblue'
    }];

    let dataArrayOfDuration = [];
    let sumDuration = 0;
    for (let item of this.cooperationsName) {
      if (this.dataset != undefined) {
        for (let i = 0; i < this.dataset.length; i++) {
          if (this.dataset[i].company === item) {
            sumDuration += this.dataset[i].timespend;
          }
        }
        dataArrayOfDuration.push(sumDuration);
        sumDuration = 0;
      }
    }
    let outArray = this.helpers.doGraphSorter(this.cooperationsName, dataArrayOfDuration);
    let outLabels = [];
    let outValues = [];
    for (let item of outArray) {
      if (item.value > 0) {
        outLabels.push(item.label);
        outValues.push(item.value);
      }
    }

    this.barChartLabelsDuration = outLabels;
    this.barChartDataDuration = [{
      data: outValues,
      label: 'Število porabljenih minut',
      backgroundColor: 'lightblue'
    }];
    this.loaded = true;
  }
}
